import { combineReducers } from 'redux';
import { encryptPersistReducer } from 'app/libs/encryptPersistReducer';
import form from './form';
import options from './options';
import requestApi from './requestApi';

const escrowV2 = combineReducers({
	form: encryptPersistReducer(
		{
			key: 'escrow-v2.form',
		},
		form,
	),
	options: encryptPersistReducer(
		{
			key: 'escrow-v2.options',
		},
		options,
	),
	requestApi: encryptPersistReducer(
		{
			key: 'escrow-v2.requestApi',
		},
		requestApi,
	),
});

export default escrowV2;
